import styled from "styled-components";

export const CheckBoxContainer = styled.div`
  //position: absolute;
  //top: 0;
  //right: 0;
  position: relative;
  display: flex;
  justify-content: center;
  //align-items: center;
`


export const CheckBoxBody = styled.div`
  position: relative;
  border: 1px solid black;
  border-radius: 100%;
  width: 30px;  
  height: 30px;
  background: white;
  z-index: 5;
`
